'use strict';

var formValidation = require('../components/formValidation');
const Recaptcha = require('../util/recaptcha');

const hiddenInputs = ['customerServiceQuestion', 'customerServiceMessage', 'customerServiceOrderNr', 'customerServiceEmail', 'subject'];

const validateEmail = (form) => {
    const emailRegex = new RegExp(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/);
    const emailVal = form.find('#email').val();
    const results = emailRegex.test(emailVal);

    if (!results) {
        $('.incorrect-email').removeClass('d-none').addClass('d-block');
        return false;
    }
    $('.incorrect-email').removeClass('d-block').addClass('d-none');
    return true;
};

const validateMessage = (form) => {
    const messageVal = form.find('.customerServiceMessage').val();
    const regex = /%/;
    const results = regex.test(messageVal);
    if (results) {
        $('.incorrect-message').removeClass('d-none').addClass('d-block');
        return false;
    }
    $('.incorrect-message').removeClass('d-block').addClass('d-none');
    return true;
};

const validateForm = (form) => {
    return validateEmail(form) && validateMessage(form);
};

const init = () => {
    $('#Case_Type__c').on('change', function () {
        $('#subject').val('Contact Form: ' + $(this).val());
    });

    $('form.cs-contact').submit(function (e) {
        e.preventDefault();

        const $form = $(this);
        const isB2B = $form.find('[name="isB2B"]').val();
        if (validateForm($form)) {
            if (isB2B !== 'true') {
                $('.incorrect-email').removeClass('d-block').addClass('d-none');
                $form.spinner().start();
                for (let index = 0; index < hiddenInputs.length; index++) {
                    let element = hiddenInputs[index];
                    if (element === 'subject') {
                        $('#subject').val('Contact Form: ' + $('#Case_Type__c').val());
                    } else {
                        $('#' + element).val($('.' + element).val());
                    }
                }
            }
            var url = $form.attr('action');
            Recaptcha.generateToken('customerservice_contact').then(function (token) {
                var data = $form.serialize();
                data += '&g-recaptcha-response=' + token;
                if (formValidation($form, data)) {
                    $.ajax({
                        url: url,
                        type: 'POST',
                        data: data,
                        success: function (data) {
                            if (data.success) {
                                if (isB2B) {
                                    $('#contactFormApprovedModalB2B').modal('show');
                                } else {
                                    $('#contactFormApprovedModal').modal('show');
                                }

                                $('.contact-form-error').removeClass('d-block').addClass('d-none');
                                $form[0].reset();
                            } else if (data.error) {
                                $('html, body').animate({ scrollTop: 0 }, 'slow');
                                $('.contact-form-error').removeClass('d-none').addClass('d-block');
                            }
                        },
                        error: function (err) {
                            if (err.responseJSON.redirectUrl) {
                                window.location.href = err.responseJSON.redirectUrl;
                            }
                        },
                        complete: function () {
                            $form.spinner().stop();
                        }
                    });
                }
            });
        }
    });
};

module.exports = {
    init: init
};
